<div class="interaction-bar-wrapper">
  <div class="interaction-bar-title">
    <ng-container *ngIf="!editView">Add Property </ng-container>
    <ng-container *ngIf="editView">Edit Property </ng-container>
  </div>
  <app-add-property-view class="add-property-view" [editedProperty]="data"></app-add-property-view>
</div>
